/*@ngInject*/
const ManageUserController = function ($rootScope, $scope, $state, $stateParams, $timeout, userType, userMediator, userUtil, localization, coreConstant, formViewerConstant, navigationStateModel, coreMediator, loadingBarHandler, modalUtil, userAction, userActionUtil, formSetMediator, userStatus) {

    localization.getTranslations().then(function (translations) {

        $scope.viewModel = {
            user: null,
            userType: parseInt($stateParams.userType),
            formId: parseInt($stateParams.formId),
            formName: null,
            userId: $stateParams.userId,
            showFormNavigation: true,
            backButtonLabel: _.get(translations, userUtil.getTitleFromStateParam(parseInt($stateParams.userType))),
            shortDateTimeFormat: 'MM/dd/yy hh:mma',
        };

        $scope.timeoutList = [];
        $scope.actions = [];
        $scope.context = {
            identifier: 'user',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            userMediator.loadUserActions($stateParams.userType, $stateParams.userId).then(function (actions) {
                processActions(actions);
            });
        }

        function processActions(actions) {
            let allActions = [];
            $scope.timeoutList.push($timeout(function () {
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;
                $scope.actionsTimeLastModified = new Date().getTime();
            }, 0));
        }

        $scope.upgradeForms = function () {
            if (!_.isNaN($scope.viewModel.formId)) {
                loadingBarHandler.showLoadingBar('loadingBar.defaultMessage');
                userMediator.upgradeForms($stateParams.userId).then(function (numberOfFormsUpgraded) {
                    if (numberOfFormsUpgraded > 0) {
                        let formsText = numberOfFormsUpgraded === 1 ? _.get(translations, 'formsViewer.formUpgrade.singularMessage') : _.get(translations, 'formsViewer.formUpgrade.pluralMessage'),
                            message = _.get(translations, 'formsViewer.formUpgrade.message');

                        message = _.replace(message, '{1}', numberOfFormsUpgraded);
                        message = _.replace(message, '{2}', formsText);

                        modalUtil.showGenericConfirm({
                            title: _.get(translations, 'formsViewer.formUpgrade.title'),
                            summary: message,
                            confirmActionButtonLabel: _.get(translations, 'formsViewer.formUpgrade.confirmActionButtonLabel')
                        }).then(function () {
                            $state.reload();
                        });
                    }
                }).finally(function () {
                    loadingBarHandler.hideLoadingBar();
                });
            }
        }

        $scope.onSelectedFormChange = function (datasetItem) {
            const formId = datasetItem.id,
                upgradeForms = _.isNaN($scope.viewModel.formId);

            $state.go('manageUser.form', {formId: formId});
            $scope.viewModel.formId = formId;
            $scope.viewModel.formName = datasetItem.name;
            userMediator.savePreviousUser(
                $scope.viewModel.user.id,
                $scope.viewModel.userType,
                $scope.viewModel.formId
            );

            if (upgradeForms) {
                $scope.upgradeForms();
            }
        };

        $scope.navigateToUserList = function () {
            $state.go('userList', {userType: $stateParams.userType});
            userMediator.resetPreviousUser();

            navigationStateModel.saveViewState('userList:' + $stateParams.userType, null);
        };

        $scope.onMenuHasSingleItem = function () {
            $scope.viewModel.showFormNavigation = false;
        };
        $scope.onMenuHasMultipleItems = function () {
            $scope.viewModel.showFormNavigation = true;
        };

        $scope.getUserStatus = function () {
            if (!_.isNil($scope.viewModel.user)) {
                return _.get(translations, 'user.manage.status.' + $scope.viewModel.user.status);
            } else {
                return '';
            }
        };

        $scope.userStatusIsInactive = function () {
            if (!_.isNil($scope.viewModel.user)) {
                return $scope.viewModel.user.status === 0;
            } else {
                return false;
            }
        };

        $scope.$on(coreConstant.event.UPDATE_USER, function (event, user) {
            if (user.id === parseInt($stateParams.userId)) {
                setUser(user);
            }
        });

        $scope.$on(coreConstant.event.DELETE_USER, function (event, user) {
            if (user.id === parseInt($stateParams.userId)) {
                $scope.navigateToUserList();
            }
        });

        $scope.$on('$destroy', function () {
            userMediator.closeUserPersistentConnection($stateParams.userId);
            _.each($scope.timeoutList, function (item) {
                if (item) {
                    $timeout.cancel(item);
                }
            });
        });

        $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
            if ((entityType === 'agent' || entityType === 'underwriter' || entityType === 'serviceuser' || entityType === 'systemuser') && parseInt($stateParams.userId) === entityId) {
                processActions(updateActionsMessage.actions);
            }
        });

        $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
            loadActions();
            loadUser();
        });

        $scope.$on(coreConstant.event.RELOAD_USER, () => {
            reloadUser();
        });

        function loadUser() {
            userMediator.loadUserById($stateParams.userId).then(function (user) {
                setUser(user);
            });
        }

        function setUser(user) {
            $scope.viewModel.user = user;
            $scope.viewModel.isDraftStatus = user.status === userStatus.STATUS_DRAFT;
            $scope.viewModel.lockedLabel = _.get(translations, 'userList.lockedLabel');
            $scope.viewModel.lockedDetail = _.get(translations, 'userList.lockedDetail');
        }

        /*
         * reloadUser redisplays the user's forms.
         * if formId or formName is specified, then the form with
         * that id or name is displayed; otherwise, the first form
         * is displayed.
         * The reason for specifying a form name is that some actions
         * (e.g., "Edit", "Discard", "Save") return a different set
         * of forms because of the user's modification-form-set.
         */
        function reloadUser(formId, formName) {
            userMediator.getForms($scope.viewModel.userId).then(function (result) {
                var nextFormId;
                result = _.filter(result, userUtil.isValidNavigationItem);
                nextFormId = result[0].id;
                if (formId || formName) {
                    _.each(result, function(item) {
                        if (item.id === formId || item.name === formName) {
                            nextFormId = item.id;
                            return false;
                        }
                        return true;
                    });
                }
                $state.go('manageUser.form', {formId: nextFormId}, {reload: true});
            });
        }

        function performUserFormSetChanges(userActionType) {
            let promise = userActionUtil.getFormSetId($stateParams.userId).then(function (formSetId) {

                function handleDiscardConfirm() {
                    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'user.discardUserChangesLoadingBar'));
                    let promise = formSetMediator.discardChanges(formSetId).then(function () {
                        reloadUser($scope.viewModel.formId, $scope.viewModel.formName);
                        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'user.discardUserChangesSuccessLoadingBar'));
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                }

                if (userActionType === userAction.EDIT) {
                    let promise = formSetMediator.startChanges(formSetId).then(function () {
                        reloadUser($scope.viewModel.formId, $scope.viewModel.formName);
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                } else if (userActionType === userAction.SAVE_CHANGES) {
                    let promise = formSetMediator.applyChanges(formSetId).then(function () {
                        reloadUser($scope.viewModel.formId, $scope.viewModel.formName);
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                } else if (userActionType === userAction.CANCEL_EDIT) {
                    modalUtil.showConfirmationModal(
                        null,
                        null,
                        null,
                        'user.discard',
                        null,
                        /*hideLoadingBar*/true,
                        handleDiscardConfirm);
                }
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case userAction.ACTIVATE:
                        userActionUtil.activateUser($stateParams.userId);
                        break;

                    case userAction.CANCEL:
                        userActionUtil.cancel($stateParams.userId);
                        break;

                    case userAction.DEACTIVATE:
                        userActionUtil.deactivateUser($stateParams.userId);
                        break;

                    case userAction.RESET_PASSWORD:
                        userActionUtil.resetPassword($stateParams.userId);
                        break;

                    case userAction.CREATE_PASSWORD:
                        userActionUtil.createPassword($stateParams.userId);
                        break;

                    case userAction.EDIT:
                        performUserFormSetChanges(userAction.EDIT);
                        break;

                    case userAction.SAVE_CHANGES:
                        performUserFormSetChanges(userAction.SAVE_CHANGES);
                        break;

                    case userAction.CANCEL_EDIT:
                        performUserFormSetChanges(userAction.CANCEL_EDIT);
                        break;

                    case userAction.UNLOCK:
                        userActionUtil.unlockUser($stateParams.userId);
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        loadActions();
        $scope.upgradeForms();
        loadUser();
    });
};

angular.module('umCore')
    .controller('manageUserController', ManageUserController);
